// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { isSendingDomain } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

export const isPatchSendingDomainResult = objectOf({
  sendingDomain: isSendingDomain,
});
